import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Plus, ShoppingCart, ChevronLeft, ChevronRight, Star, Check } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Cart sound effect
const playCartSound = () => {
  const audio = new Audio('data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU4Ljc2LjEwMAAAAAAAAAAAAAAA//tQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAABhgC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7//////////////////////////////////////////////////////////////////8AAAAATGF2YzU4LjEzAAAAAAAAAAAAAAAAJAAAAAAAAAAAAYZNLBruAAAAAAD/+1DEAAAGAAGn9AAAIwwKd/OMACQAABpAAAABQGCAIAh8EAQBAH/BAEAQBA4sIAgCAIHc+ZQEAXP/6gIAgCAJnn/pAEPBA1/84CgIAgGOD//lwGBsMsP/nkQGPgg+f+8MYgIJn+MMDAYGBQM8H//+DBg4f//5wcGIBAED///+UGIIgCDoGJgcf////h+c/////BgxiRq7/2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//tQxAADwAABpAAAACAAADSAAAAE//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8=');
  audio.volume = 0.3;
  audio.play().catch(() => {});
};

// Customer reviews
const PRODUCT_IMAGES = {
  promescent: 'https://www.promescent.com/cdn/shop/files/20Spray_1024x1024_da9bd637-8d47-4570-86e5-d4a698f59e90.webp?v=1738251213',
  back2game: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/m1ozw06h_%2B%20%281%29.png',
  titan: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/uhp34fvx_4.png',
  vitamel: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/o2gggziq_3.png',
};

const CUSTOMER_REVIEWS = [
  { name: 'קונסטנטין מ.', product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent, review: 'אני משתמש במוצר הזה כבר כ-3 שנים ואני יכול לומר בכנות שהמוצר עצמו ממש טוב. הוא תמיד עבד מצוין בשבילי.', rating: 5 },
  { name: 'קווין ב.', product: "ג'ל עוררות", image: PRODUCT_IMAGES.titan, review: 'אני משתמש במוצר הזה כבר בערך שנה. קניתי אותו משום מקום, ואני רוצה לספר לכם איזו מציאה. אשתי נהנתה ממנו מאוד.', rating: 5 },
  { name: 'אהרון ס.', product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent, review: 'מרחתי את זה לפי ההוראות ו-וואה. לקחת את זה אינטנו לחופשה בשבע שעבר ולא אמרו לנו לאשרי לפני כן.', rating: 5 },
  { name: "קווין ג'.", product: 'ויטמל', image: PRODUCT_IMAGES.vitamel, review: 'התחלתי להשתמש במוצר הזה אחרי שהאורולוג שלי המליץ עליו. אני מרגיש צעיר ב-20 שנה ונהנה ממנו הרבה.', rating: 5 },
  { name: 'יוסי כ.', product: 'Back 2 Game', image: PRODUCT_IMAGES.back2game, review: 'מוצר מדהים! הרגשתי שיפור משמעותי כבר אחרי שבועיים של שימוש. ממליץ בחום!', rating: 5 },
  { name: 'אבי מ.', product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent, review: 'הזמנתי בספקנות אבל התוצאות מדברות בעד עצמן. האנרגיה שלי עלתה והביצועים השתפרו.', rating: 5 },
  { name: 'דני ל.', product: "ג'ל עוררות", image: PRODUCT_IMAGES.titan, review: 'אחרי שניסיתי הרבה מוצרים, סוף סוף מצאתי משהו שעובד. תודה רבה!', rating: 5 },
  { name: 'משה ר.', product: 'Back 2 Game', image: PRODUCT_IMAGES.back2game, review: 'המוצר הגיע מהר ובאריזה דיסקרטית. התוצאות פשוט מעולות, ממליץ לכולם.', rating: 5 },
  { name: 'רון ש.', product: 'ויטמל', image: PRODUCT_IMAGES.vitamel, review: 'בן 52 וחשבתי שאין מה לעשות. המוצרים החזירו לי את הביטחון העצמי!', rating: 5 },
  { name: 'גיל ב.', product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent, review: 'שימוש יומיומי כבר 3 חודשים. השינוי הוא פשוט מטורף. תודה!', rating: 5 },
  { name: 'עמית ד.', product: 'Back 2 Game', image: PRODUCT_IMAGES.back2game, review: 'לא האמנתי שזה יעבוד, אבל אחרי חודש אני מרגיש כמו בן 30 שוב.', rating: 5 },
  { name: 'אורי נ.', product: "ג'ל עוררות", image: PRODUCT_IMAGES.titan, review: 'המוצר הטוב ביותר שניסיתי. טבעי, בטוח, ועובד מעולה. 5 כוכבים!', rating: 5 },
  { name: 'יעקב ה.', product: 'ויטמל', image: PRODUCT_IMAGES.vitamel, review: 'הרכיבים הטבעיים עשו את ההבדל. מרגיש יותר אנרגטי ובריא מתמיד.', rating: 5 },
  { name: 'שמעון פ.', product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent, review: 'הזמנתי פעם שנייה כי המוצר פשוט עובד. שירות מעולה ותוצאות אמיתיות.', rating: 5 },
  { name: 'רועי ש.', product: 'Back 2 Game', image: PRODUCT_IMAGES.back2game, review: 'מוצר טוב מאוד, לקח כמה ימים עד שהרגשתי את ההשפעה אבל מאז - שיפור ניכר.', rating: 4 },
  { name: 'ירון ז.', product: "ג'ל עוררות", image: PRODUCT_IMAGES.titan, review: 'הטיטאן ג\'ל שינה את חווית הזוגיות שלנו. מומלץ בחום, נספג מהר ותחושה מדהימה.', rating: 5 },
];

const Products = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentReview, setCurrentReview] = useState(0);
  const { addToCart } = useCart();
  const [addedProducts, setAddedProducts] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  
  // Auto-rotate reviews every 6 seconds
  const nextReview = useCallback(() => {
    setCurrentReview((prev) => (prev + 1) % CUSTOMER_REVIEWS.length);
  }, []);
  
  const prevReview = useCallback(() => {
    setCurrentReview((prev) => (prev - 1 + CUSTOMER_REVIEWS.length) % CUSTOMER_REVIEWS.length);
  }, []);
  
  useEffect(() => {
    const interval = setInterval(nextReview, 6000);
    return () => clearInterval(interval);
  }, [nextReview]);
  
  useEffect(() => {
    fetchProducts();
    // Track unique visit
    axios.post(`${API}/track/visit`, { page: 'products' }).catch(() => {});
  }, []);
  
  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${API}/products`);
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
      toast.error('שגיאה בטעינת המוצרים');
    } finally {
      setLoading(false);
    }
  };
  
  const handleAddToCart = (product, e) => {
    e.stopPropagation();
    if (addedProducts[product.id]) {
      navigate('/cart');
    } else {
      addToCart(product);
      playCartSound();
      setAddedProducts(prev => ({ ...prev, [product.id]: true }));
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 2000);
    }
  };
  
  if (loading) {
    return (
      <div className="container py-16" data-testid="products-loading">
        <div className="text-center">
          <p className="text-xl text-stone-600">טוען מוצרים...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="container py-16" data-testid="products-page">
      {/* Cart Popup - slides from top */}
      {showPopup && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 bg-green-500 text-white px-8 py-4 rounded-2xl shadow-2xl flex items-center gap-3 animate-slide-down" data-testid="cart-popup">
          <Check className="w-6 h-6" />
          <span className="font-bold text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>נוסף לסל</span>
        </div>
      )}
      
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="products-title">
          המוצרים שלנו
        </h1>
        <p className="text-base md:text-lg text-stone-600">
          מגוון רחב של מוצרים איכותיים לבריאות הגבר
        </p>
      </div>
      
      {/* Products Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="products-grid">
        {/* Packages & Deals Card */}
        <div
          data-testid="packages-deals-card"
          onClick={() => navigate('/packages')}
          className="group relative bg-white rounded-2xl overflow-hidden border-4 border-[#D97706] hover:shadow-xl transition-all duration-300 cursor-pointer"
        >
          <div className="absolute top-0 left-0 right-0 bg-[#D97706] text-white text-center py-2 z-10">
            <span className="font-bold text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>מבצע מיוחד!</span>
          </div>
          <div className="aspect-square overflow-hidden relative pt-8">
            <img
              src="https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/sg9j9f08_%D7%9C%D7%97%D7%99%D7%96%D7%95%D7%A7%20%D7%95%D7%A9%D7%99%D7%A4%D7%95%D7%A8%20%D7%94%D7%90%D7%95%D7%9F%20%D7%94%D7%92%D7%91%D7%A8%D7%99%20%28701%20x%20700%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%28850%20x%20700%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%28700%20x%20700%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%28700%20x%20700%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29%20%28700%20x%20700%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29.png"
              alt="חבילות ומבצעים"
              className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
            />
          </div>
          
          <div className="p-6">
            <h3 className="text-xl font-semibold text-[#2C3E2D] mb-2 text-center" style={{ fontFamily: 'Heebo, sans-serif' }}>
              חבילות ומבצעים
            </h3>
            
            <p className="text-stone-600 text-sm mb-4 leading-relaxed text-center">
              חבילות משתלמות במחירים מיוחדים
            </p>
            
            <div className="text-center">
              <span className="inline-block px-6 py-2 rounded-full bg-[#D97706] text-white font-bold" style={{ fontFamily: 'Heebo, sans-serif' }}>
                לצפייה במבצעים
              </span>
            </div>
          </div>
        </div>
        
        {/* Treat Your Partner Card */}
        <div
          data-testid="treat-partner-card"
          onClick={() => navigate('/partner')}
          className="group relative bg-white rounded-2xl overflow-hidden border-4 border-pink-400 hover:shadow-xl transition-all duration-300 cursor-pointer"
        >
          <div className="absolute top-0 left-0 right-0 bg-gradient-to-l from-pink-500 to-pink-600 text-white text-center py-2 z-10">
            <span className="font-bold text-lg" style={{ fontFamily: 'Heebo, sans-serif' }}>תפנק את בת הזוג</span>
          </div>
          <div className="aspect-square overflow-hidden relative pt-8">
            <img
              src="https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/9d7oitzp_%2B%20%28701%20x%20700%20%D7%A4%D7%99%D7%A7%D7%A1%D7%9C%29.png"
              alt="תפנק את בת הזוג"
              className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
            />
          </div>
          
          <div className="p-6">
            <h3 className="text-xl font-semibold text-[#2C3E2D] mb-2 text-center" style={{ fontFamily: 'Heebo, sans-serif' }}>
              תפנק את בת הזוג
            </h3>
            
            <p className="text-stone-600 text-sm mb-4 leading-relaxed text-center">
              מוצרים שיהפכו את בת הזוג שלך ליותר מאושרת
            </p>
            
            <div className="text-center">
              <span className="inline-block px-6 py-2 rounded-full bg-pink-500 text-white font-bold" style={{ fontFamily: 'Heebo, sans-serif' }}>
                לצפייה במוצרים
              </span>
            </div>
          </div>
        </div>
        
        {products.map((product) => (
          <div
            key={product.id}
            data-testid={`product-item-${product.id}`}
            onClick={() => navigate(`/products/${product.id}`)}
            className="group relative bg-white rounded-2xl overflow-hidden border border-stone-100 hover:border-[#D97706]/30 transition-all duration-300 hover:shadow-lg cursor-pointer"
          >
            <div className="aspect-square overflow-hidden relative">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              />
              {!product.in_stock && (
                <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                  <span className="bg-white text-[#2C3E2D] px-4 py-2 rounded-full font-bold">
                    אזל מהמלאי
                  </span>
                </div>
              )}
            </div>
            
            <div className="p-6">
              <div className="mb-2">
                <span className="text-xs font-semibold text-[#D97706] bg-[#D97706]/10 px-3 py-1 rounded-full">
                  {product.category}
                </span>
              </div>
              
              <h3 className="text-xl font-semibold text-[#2C3E2D] mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>
                <bdi>{product.name}</bdi>
              </h3>
              
              <p className="text-stone-600 text-sm mb-4 leading-relaxed">
                {product.description}
              </p>
              
              <div className="flex items-center justify-between">
                <span className="flex items-baseline gap-2" style={{ fontFamily: 'Heebo, sans-serif' }}>
                  {product.old_price && product.old_price > product.price && (
                    <span className="text-base text-stone-400 line-through">₪{product.old_price.toFixed(0)}</span>
                  )}
                  <span className="text-2xl font-bold text-[#D97706]">₪{product.price.toFixed(2)}</span>
                </span>
                
                <button
                  onClick={(e) => handleAddToCart(product, e)}
                  disabled={!product.in_stock}
                  data-testid={`add-to-cart-${product.id}`}
                  className={`h-10 px-6 rounded-full font-medium transition-all duration-300 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed ${
                    addedProducts[product.id]
                      ? 'bg-green-500 text-white hover:bg-green-600'
                      : 'bg-[#2C3E2D] text-white hover:bg-[#1F2E20]'
                  }`}
                  style={{ fontFamily: 'Heebo, sans-serif' }}
                >
                  {addedProducts[product.id] ? (
                    <>
                      <ShoppingCart className="w-4 h-4" />
                      לרכישה
                    </>
                  ) : (
                    <>
                      <Plus className="w-4 h-4" />
                      הוסף לסל
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {products.length === 0 && (
        <div className="text-center py-16" data-testid="no-products">
          <ShoppingCart className="w-16 h-16 text-stone-300 mx-auto mb-4" />
          <p className="text-xl text-stone-600">לא נמצאו מוצרים</p>
        </div>
      )}
      
      {/* Customer Reviews Carousel */}
      <div className="mt-16" data-testid="reviews-carousel">
        <h2 className="text-2xl md:text-3xl font-semibold text-[#2C3E2D] mb-8 text-center" style={{ fontFamily: 'Heebo, sans-serif' }}>
          מה הלקוחות אומרים
        </h2>
        
        <div className="relative max-w-2xl mx-auto">
          {/* Left Arrow */}
          <button
            onClick={prevReview}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-stone-100 transition-colors"
            data-testid="review-prev"
          >
            <ChevronLeft className="w-6 h-6 text-[#2C3E2D]" />
          </button>
          
          {/* Review Card */}
          <div className="mx-12 bg-white rounded-2xl p-6 border border-stone-200 shadow-sm" data-testid="review-card">
            {/* Product Image & Name */}
            <div className="flex flex-col items-center mb-4">
              <div className="w-24 h-28 mb-3 flex items-center justify-center">
                <img src={CUSTOMER_REVIEWS[currentReview].image} alt={CUSTOMER_REVIEWS[currentReview].product} className="max-h-28 max-w-24 object-contain" />
              </div>
              <p className="font-bold text-[#2C3E2D] text-sm mb-2" style={{ fontFamily: 'Heebo, sans-serif' }}>{CUSTOMER_REVIEWS[currentReview].product}</p>
            </div>
            {/* Stars */}
            <div className="flex justify-center gap-1 mb-1">
              {[...Array(CUSTOMER_REVIEWS[currentReview].rating || 5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-[#D97706] text-[#D97706]" />
              ))}
              {[...Array(5 - (CUSTOMER_REVIEWS[currentReview].rating || 5))].map((_, i) => (
                <Star key={`e-${i}`} className="w-5 h-5 text-stone-300" />
              ))}
            </div>
            <p className="text-xs text-stone-400 text-center mb-3">מתוך 55</p>
            
            {/* Review Text */}
            <p className="text-stone-600 text-center mb-4 min-h-[60px]" style={{ fontFamily: 'Heebo, sans-serif' }}>
              "{CUSTOMER_REVIEWS[currentReview].review}"
            </p>
            
            {/* Reviewer Name */}
            <div className="flex items-center justify-center gap-3">
              <p className="text-[#2C3E2D] font-semibold" style={{ fontFamily: 'Heebo, sans-serif' }}>
                {CUSTOMER_REVIEWS[currentReview].name}
              </p>
              <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full font-medium">קונה מאומת</span>
            </div>
            
            {/* Dots indicator */}
            <div className="flex justify-center gap-2 mt-4">
              {CUSTOMER_REVIEWS.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentReview(index)}
                  className={`w-2 h-2 rounded-full transition-colors ${
                    index === currentReview ? 'bg-[#D97706]' : 'bg-stone-300'
                  }`}
                  data-testid={`review-dot-${index}`}
                />
              ))}
            </div>
          </div>
          
          {/* Right Arrow */}
          <button
            onClick={nextReview}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-stone-100 transition-colors"
            data-testid="review-next"
          >
            <ChevronRight className="w-6 h-6 text-[#2C3E2D]" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Products;